import api from "../config";
import URLS from "../../constants/urls";
export const _getShape = async (siteId, floorId, pageNumber, pageSize) => {
    const response = await api.get(`${URLS.SHAPE}/${siteId}/${floorId}?pageNumber=${pageNumber}&pageSize=${pageSize}`);
    return response.data;
};
